import { travel } from 'api';
import { FlightStretch, Trip } from 'models/flightSearch';

import { UpsellBySectorRequest, UpSellResponse } from 'models/upsell';
import moment from 'moment';
import { store } from 'store';
import { convertTime } from 'utils/time';

export interface UpSellRequest {
  searchId: string;
  optionId: number;
  sessionToken: string;
  DistanceRestriction?: string;
  DepartureDate: Date;
  DepartureAirport: string;
  ArrivalAirport: string;
  userId: string;
  lowestLogicalFare?: number;
  SectorsCount?: number;
  Adults: number;
}

export const getAirUpSellWholeTrip = async (params: UpSellRequest): Promise<UpSellResponse> => {
  try {
    const response = await travel.get('Air/AirUpSellWholeTrip', {
      params,
    });
    return response.data.data;
  } catch (error) {
    return error.data;
  }
};

export const getAirUpSell = async (params: UpSellRequest): Promise<UpSellResponse> => {
  try {
    const response = await travel.get('Air/AirUpSell', {
      params,
    });
    return response.data.data;
  } catch (error) {
    return error.data;
  }
};

export const getGetUpsellBySectorOptions = async (optionId:number,sectorNumber:number)=>{
  try {
    const { accountResult } = store.getState().user;
    if (!accountResult) return;
    const { sessionToken, id: loggedUserId,userGroupId } = accountResult;

    const {  search, travelers, arrivalPoint, 
      departurePoint,departureDate,baggageIncluded, cabin, directFlight,returnDate,departureTime,returnTime, flightStretch, multiDestinationTrips } = store.getState().flights;
    if (!search) return;
    const {  distanceRestriction, lowestLogicalFare } = search;

    let trips: Trip[] = [];
    if (flightStretch !== FlightStretch.MULTIDESTINATION) {
      const departureDateTime = departureTime
        ? `${moment(departureDate).format('YYYY-MM-DD')}T${convertTime(departureTime)}`
        : `${moment(departureDate).format('YYYY-MM-DD')}T00:00:01Z`;
      trips = [
        new Trip(departurePoint.code, arrivalPoint.code, departureDateTime, cabin, baggageIncluded, directFlight),
      ];

      if (returnDate) {
        const returnDateTime = returnTime
          ? `${moment(returnDate).format('YYYY-MM-DD')}T${convertTime(returnTime)}`
          : `${moment(returnDate).format('YYYY-MM-DD')}T00:00:02Z`;
        trips.push(
          new Trip(arrivalPoint.code, departurePoint.code, returnDateTime, cabin, baggageIncluded, directFlight),
        );
      }
    } else {
      if (multiDestinationTrips && multiDestinationTrips.length > 0) {
        for (let index = 0; index < multiDestinationTrips.length; index++) {
          const multiTrip = multiDestinationTrips[index];

          const departureDateTime = multiTrip.departureTime
            ? `${moment(multiTrip.departureDate).format('YYYY-MM-DD')}T${convertTime(multiTrip.departureTime)}`
            : `${moment(multiTrip.departureDate).format('YYYY-MM-DD')}T00:00:01Z`;

          trips.push(
            new Trip(
              multiTrip.departurePoint.code,
              multiTrip.arrivalPoint.code,
              departureDateTime,
              cabin,
              baggageIncluded,
              directFlight,
            ),
          );
        }
      }
    } 

    const upsellBySectorRequest: UpsellBySectorRequest = {
      trips: trips,
      searchId: search.searchId,
      sessionToken: sessionToken,
      userId: loggedUserId,
      userGroupId: travelers && travelers.length > 0 ? travelers[0].userGroupId : userGroupId,
      adults: travelers && travelers.length > 0 ? travelers.length : 1,
      lowestLogicalFare: lowestLogicalFare,
      distanceRestriction: distanceRestriction,
      optionId: optionId,
      sectorNumber: sectorNumber,
      previousOptions: store.getState().flights.optionsIds.length > 0 ? store.getState().flights.optionsIds : []
    }

    const response = await travel.post<any>('AirBySector/Upsell', upsellBySectorRequest,{
      params: {
        token: accountResult?.sessionToken || '',
        companyId: accountResult.companyId,
        country_code: localStorage.getItem('country_code'),
      }
    })

    return response.data;
    
  }
  catch (error) {
    return error.data;
  }
}
